import { styled } from '@mui/material';

import { Skeleton } from '@app-velocity/ui';

import { useReportContext } from '../../../../context/useReportContext';
import { InfoSection } from '../../../../components/InfoSection';

import { Metrics } from './components/Metrics';

const MetricsSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  padding: `${theme.spacing(4)} 0`,
}));

export const UsabilityResults = () => {
  const { isLoading } = useReportContext();

  return (
    <InfoSection tooltip="prototypes:report.usability_results.tooltip">
      <InfoSection.Title title="prototypes:report.usability_results.title" />
      <MetricsSection>
        {isLoading ? (
          <>
            <Skeleton height={34} margin="0" />
            <Skeleton height={34} margin="0" />
            <Skeleton height={34} margin="0" />
            <Skeleton height={34} margin="0" />
          </>
        ) : (
          <Metrics />
        )}
      </MetricsSection>
    </InfoSection>
  );
};
